import { featuredReviews } from "@/mocks/fengchiData";

export default function FeaturedReviews() {
  return (
    <section id="reviews" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium">
            <i className="ri-article-line" />
            深度影评精选
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            不止打一个分，我们把理由也写清楚了
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            分数只能告诉你方向，真正的判断还得看细节。以下三篇长评从结构、影像、表演等角度展开，
            既有具体的观察，也会坦白作品的不足——看完你大概就能决定，它是不是你的那杯茶。
          </p>
        </div>

        <div className="mt-8 md:mt-12 space-y-8 md:space-y-14">
          {featuredReviews.map((review, index) => (
            <article
              key={review.id}
              className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-start"
            >
              <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                <div className="relative rounded-lg overflow-hidden w-full aspect-[5/4] bg-background-100">
                  <img
                    src={review.image}
                    alt={`${review.title} 配图`}
                    title={`风驰影院 影评 ${review.title}`}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-accent-500 text-background-50 text-sm font-bold">
                    <i className="ri-star-fill" />
                    {review.score}
                  </span>
                </div>
              </div>

              <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-heading font-bold">
                    {review.author.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{review.author}</p>
                    <p className="text-xs text-foreground-500">
                      {review.date} · {review.readTime}
                    </p>
                  </div>
                </div>

                <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug">
                  {review.title}
                </h3>

                <p className="mt-4 text-base md:text-lg text-accent-800 leading-relaxed border-l-2 border-accent-400 pl-4">
                  {review.excerpt}
                </p>

                <div className="mt-4 space-y-3">
                  {review.body.map((paragraph, pIndex) => (
                    <p
                      key={pIndex}
                      className="text-sm md:text-base text-foreground-700 leading-relaxed"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}